import styled from '@emotion/styled'
import { MediaQueries, theme } from '@hhgtech/hhg-components/misc'

export const StyledSpotlightSubot = styled.div`
  height: 100%;
  border: 1px solid ${theme.colors.neutral100};
  border-radius: ${theme.borderRadius};
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.04), 0px 0px 2px rgba(0, 0, 0, 0.06),
    0px 0px 1px rgba(0, 0, 0, 0.04);
  img {
    width: 48px;
    height: 48px;
  }
  ${MediaQueries.mbUp} {
    padding: 8px 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1;
    text-decoration: none;
    cursor: pointer;

    img {
      margin-right: 16px;
    }
  }

  &[data-is-unique-subot='true'] {
    ${MediaQueries.mbDown} {
      display: flex;
      flex: 1;
      justify-content: center;
      align-items: center;

      img {
        margin-right: 16px;
      }
    }
  }

  ${MediaQueries.mbDown} {
    padding: 16px;
    p {
      height: 44px;
      overflow: hidden;
    }
  }
`

export const StyledSpotlightSubotList = styled.div`
  .list-subot {
    display: flex;

    justify-content: center;
    margin-top: 32px;

    ${MediaQueries.mbUp} {
      gap: 32px;
    }
    ${MediaQueries.mbDown} {
      gap: 8px;
    }
    .container {
      .section {
        ${MediaQueries.mbDown} {
          margin: 0 16px 0 0;
        }
        .grid-layout {
          ${MediaQueries.mbUp} {
            grid-column-gap: 32px;
            padding: 0 96px 0 0;
          }

          ${MediaQueries.mbDown} {
            grid-column-gap: 8px;
            padding: 0 24px 0 0;
          }
        }
      }
    }
  }
`
